import React, { useContext, useMemo } from 'react';

import AnalyticsMetaContext from './context';

const emptyProps = {};

export interface AnalyticsMetaProviderProps {
  entryPoint?: string | undefined;
  additionalEventProps?: Record<string, unknown>;
}

const AnalyticsMetaProvider: React.FC<React.PropsWithChildren<AnalyticsMetaProviderProps>> = ({
  children,
  ...props
}) => {
  const parentCtx = useContext(AnalyticsMetaContext);

  const entryPoint = props.entryPoint ?? parentCtx.entryPoint;
  const additionalPropsFromProps = props.additionalEventProps ?? emptyProps;
  const additionalEventProps = useMemo(
    () => ({
      ...parentCtx.additionalEventProps,
      ...additionalPropsFromProps,
    }),
    [parentCtx.additionalEventProps, additionalPropsFromProps],
  );

  const contextValue = useMemo(
    () => ({
      entryPoint,
      additionalEventProps,
    }),
    [additionalEventProps, entryPoint],
  );

  return (
    <AnalyticsMetaContext.Provider value={contextValue}>{children}</AnalyticsMetaContext.Provider>
  );
};

export default AnalyticsMetaProvider;
